import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';

// Phase 9.6 (D-S3, R2-9-3 = A): Settings › Channels shows "All channels" and one page per channel type, always.
// One place says which type an inbox belongs to (the same rule as its icon, components-next/icon/provider.js, so a
// Twilio WhatsApp lands in WhatsApp and a Twilio voice number in Voice), which new-inbox forms create each type
// (the `sub_page` of settings_inboxes_page_channel) and when a form can be used (what ChannelItem checked).
export const CHANNEL_TYPES = [
  { key: 'website', icon: 'i-woot-website', create: ['website'] },
  { key: 'email', icon: 'i-woot-mail', create: ['email'] },
  { key: 'whatsapp', icon: 'i-woot-whatsapp', create: ['whatsapp'] },
  { key: 'sms', icon: 'i-woot-sms', create: ['sms'] },
  {
    key: 'social',
    icon: 'i-woot-messenger',
    create: ['facebook', 'instagram', 'tiktok'],
  },
  { key: 'telegram', icon: 'i-woot-telegram', create: ['telegram'] },
  { key: 'line', icon: 'i-woot-line', create: ['line'] },
  { key: 'api', icon: 'i-woot-api', create: ['api'] },
  { key: 'voice', icon: 'i-woot-voice', create: ['voice', 'whatsapp_call'] },
];

export const channelTypeByKey = key =>
  CHANNEL_TYPES.find(type => type.key === key);

export const channelTypeOfInbox = inbox => {
  const type = inbox?.channel_type;
  const voiceEnabled = inbox?.voice_enabled || inbox?.voiceEnabled;
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'website';
    case INBOX_TYPES.EMAIL:
      return 'email';
    case INBOX_TYPES.WHATSAPP:
      return 'whatsapp';
    case INBOX_TYPES.TWILIO:
      if (inbox.medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP) return 'whatsapp';
      return voiceEnabled ? 'voice' : 'sms';
    case INBOX_TYPES.SMS:
      return 'sms';
    case INBOX_TYPES.FB:
    case INBOX_TYPES.INSTAGRAM:
    case INBOX_TYPES.TIKTOK:
    case INBOX_TYPES.TWITTER:
      return 'social';
    case INBOX_TYPES.TELEGRAM:
      return 'telegram';
    case INBOX_TYPES.LINE:
      return 'line';
    default:
      return 'api';
  }
};

// TikTok is offered only when the app is configured (ChannelList's rule).
export const isCreationListed = key =>
  key !== 'tiktok' || !!window.chatwootConfig?.tiktokAppId;

// ChannelItem's rule, unchanged: which new-inbox forms the account can use.
export const isCreationAvailable = (key, features = {}) => {
  if (!Object.keys(features).length) return false;
  const config = window.chatwootConfig || {};
  if (key === 'website') return !!features.channel_website;
  if (key === 'facebook')
    return !!features.channel_facebook && !!config.fbAppId;
  if (key === 'email') return !!features.channel_email;
  if (key === 'instagram') {
    return !!features.channel_instagram && !!config.instagramAppId;
  }
  if (key === 'tiktok')
    return !!features.channel_tiktok && !!config.tiktokAppId;
  if (key === 'voice' || key === 'whatsapp_call') {
    return !!features.channel_voice;
  }
  return ['twilio', 'api', 'whatsapp', 'sms', 'telegram', 'line'].includes(key);
};
